
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slugCoach]/video-coaching",
      function () {
        return require("private-next-pages/coaches/[slugCoach]/video-coaching/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slugCoach]/video-coaching"])
      });
    }
  